import axios from './axyos';
import type { CaptchaPayload } from './registerApi';

export interface CustomerSupportPayload {
  subject: string;
  description: string;
  email?: string;
  captcha: CaptchaPayload;
}

export const sendCustomerSupportRequestApi = (data: CustomerSupportPayload) => {
  return axios.post('/customer-support', data);
};
